export default __webpack_public_path__ + "static/media/rockerspro.1ce0e830.svg";